// src/tour/components/ChoiceCard.js
//
// Presentational card for `type: 'choice_card'` steps. Renders a title, body,
// and N option buttons. Pure — it dispatches nothing itself; the caller (the
// overlay) passes onSelect and wires it to useTour actions.

import { TC, touchBtn } from './tourTheme'

export default function ChoiceCard({ title, body, options = [], onSelect }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        background: TC.bubbleBg,
        border: `1px solid ${TC.bubbleBorder}`,
        borderRadius: 16,
        boxShadow: '0 12px 48px rgba(44,29,20,0.28)',
        padding: '28px 24px',
        maxWidth: 460,
        width: 'calc(100vw - 32px)',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ fontFamily: TC.fHead, fontSize: 22, color: TC.body, lineHeight: 1.3 }}>
        {title}
      </div>
      {body && (
        <div style={{ fontFamily: TC.fBody, fontSize: 15, color: TC.muted, marginTop: 12, lineHeight: 1.5 }}>
          {body}
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 22 }}>
        {options.map((opt, i) => {
          const primary = opt.action === 'continue'
          return (
            <button
              key={i}
              onClick={() => onSelect?.(opt)}
              style={{
                ...touchBtn,
                textAlign: 'left',
                width: '100%',
                lineHeight: 1.4,
                border: primary ? 'none' : `1px solid ${TC.bubbleBorder}`,
                background: primary ? TC.primary : 'transparent',
                color: primary ? '#fff' : TC.body,
                fontWeight: primary ? 600 : 500,
              }}
            >
              {opt.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
